import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';
import { Award } from 'lucide-react';

// Renkler tablo özet kartlarıyla aynı dilde — operatör hızlıca eşleştirsin.
const BUCKET_META = [
  { key: 'expired', label: 'Süresi Geçmiş', color: '#dc2626' },
  { key: 'expiring_30', label: '≤ 30 gün', color: '#f97316' },
  { key: 'expiring_60', label: '31–60 gün', color: '#f59e0b' },
  { key: 'expiring_90', label: '61–90 gün', color: '#eab308' },
];

/**
 * 30/60/90 sertifika yenileme dağılımının yatay bar grafiği.
 * `summary` prop'u backend'in /auditor/certificate-renewals.summary alanı.
 */
export default function CertExpiryChart({ summary, className = '' }) {
  if (!summary) return null;

  const data = BUCKET_META.map(b => ({
    name: b.label,
    value: summary[b.key] || 0,
    color: b.color,
  }));
  const total = data.reduce((acc, d) => acc + d.value, 0);

  return (
    <Card className={className} data-testid="cert-expiry-chart">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm flex items-center gap-2">
          <Award className="w-4 h-4" />
          Sertifika Yenileme Dağılımı
          <span className="ml-auto text-xs font-normal text-muted-foreground">
            Toplam {total}
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {total === 0 ? (
          <div className="text-center text-xs text-muted-foreground py-8">
            Bu eşik için yenilenmesi gereken sertifika yok.
          </div>
        ) : (
          <div className="h-[180px]">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data} layout="vertical" margin={{ left: 10, right: 10, top: 4, bottom: 4 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" horizontal={false} />
                <XAxis type="number" stroke="hsl(var(--muted-foreground))" fontSize={11} allowDecimals={false} />
                <YAxis type="category" dataKey="name" stroke="hsl(var(--muted-foreground))" fontSize={11} width={90} />
                <Tooltip
                  cursor={{ fill: 'hsl(var(--muted) / 0.4)' }}
                  contentStyle={{
                    background: 'hsl(var(--background))',
                    border: '1px solid hsl(var(--border))',
                    borderRadius: 8,
                    fontSize: 12,
                  }}
                  formatter={(v) => [`${v} sertifika`, '']}
                />
                <Bar dataKey="value" radius={[0, 4, 4, 0]}>
                  {data.map((d, idx) => (
                    <Cell key={idx} fill={d.color} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
